// TODO: Move to unit tests
// console.assert(isExcelFile({ ext: 'xls' }) == true, 'xls is an Excel file');
// console.assert(isExcelFile({ ext: 'xlsx' }) == true, 'xlsx is an Excel file');
// console.assert(isCsvFile({ ext: 'csv' }) == true, 'csv is a CSV file');

// console.assert(isValidFileType({ ext: 'xls' }) == true, 'xls is a valid file type');
// console.assert(isValidFileType({ ext: 'xlsx' }) == true, 'xlsx is a valid file type');
// console.assert(isValidFileType({ ext: 'csv' }) == true, 'csv is a valid file type');

// const asyncPipe = (...fnsArray) => {
//   return x => (
//     fnsArray.reduce(async (acc, fn) => fn(await acc), x)
//   );
// };

export interface IUploadFileService {
  fileModel: any;
  $onInit(): void;
  unsubscribeFromStore(): void;
  getFile(): any;
  selectFile(file: any): void;
  deleteFile?(file: any): void;
}

// Because we're simply assigning many of these methods rather than defining them here
// We only need integration tests rather than unit tests here
class SelectFilesPaneCtrl {
  static bindings = {
    fileUploader: '<',
    multipleFiles: '<',
    acceptableExtensions: '<',
    allowDelete: '<',
    showDownloadUrl: '<',
    showFileSize: '<',
    disabledFileSelection: '<'
  };

  fileUploader: IUploadFileService;
  multipleFiles;
  acceptableExtensions: string[];
  acceptableExtensionsString: string;
  disabledFileSelection;

  isOnlyShowOneFileVisible = false;

  // This could be a mixin since we do it in each component
  unsubscribeFromStore;

  constructor(private UploadModel) {
    'ngInject';
  }

  $onInit() {
    if (this.fileUploader) {
      // FIXME: fileUploader should be a service instance
      this.fileUploader.$onInit();
    }
  }

  $onChanges(changes) {
    if (
      changes.acceptableExtensions &&
      Array.isArray(changes.acceptableExtensions.currentValue)
    ) {
      this.updateAcceptableExtensions(
        changes.acceptableExtensions.currentValue
      );
    }
  }

  $onDestroy() {
    this.fileUploader.unsubscribeFromStore();
  }

  /**
   * Converts an array of extensions from ['xls', 'xlsx'] to a string '.xls,.xlsx'
   *
   * @param {string[]} extensions [description]
   */
  updateAcceptableExtensions(extensions: string[]) {
    this.acceptableExtensionsString = extensions
      .map((extension) => '.'.concat(extension))
      .join(',');
  }

  convertFileToArray() {
    if (this.fileUploader) {
      let getFiles = this.fileUploader.getFile();

      if (getFiles === null) {
        return [];
      }
      return Array.isArray(getFiles) ? getFiles : [getFiles];
    } else {
      return [];
    }
  }

  /**
   * Call this when a file is selected
   *
   * @param {[type]} $files          Some uploads will support multiple
   * @param {[type]} $file           Some only upload one file
   * @param {[type]} $newFiles       [description]
   * @param {[type]} $duplicateFiles [description]
   * @param {[type]} $invalidFiles   [description]
   * @param {[type]} $event          [description]
   */
  selectFile($files, $newFiles, $duplicateFiles, $invalidFiles, $event) {
    // Reset warning when they try to upload new files
    this.isOnlyShowOneFileVisible = false;

    this.fileUploader.selectFile($files);
  }

  deleteFile(file) {
    this.fileUploader.deleteFile(file);
  }
}

export const SelectFilesPaneComponent = {
  template: require('./selectFilesPane.component.html'),
  transclude: {
    uploadHeader: '?uploadHeader',
    attachmentHeader: '?attachmentHeader'
  },
  controller: SelectFilesPaneCtrl,
  bindings: SelectFilesPaneCtrl.bindings
};
